import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import AppIcon from "../components/AppIcon";
import { APPS } from "../data/apps";
import { mailto } from "../data/site";
import "../styles/docs.css";

const COLS = [
  { key: "privacy", label: "privacy", name: "개인정보처리방침" },
  { key: "terms", label: "terms", name: "이용약관" },
  { key: "support", label: "support", name: "고객지원" },
  { key: "delete-account", label: "delete_account", name: "계정 삭제" },
];

export default function LegalPage() {
  useEffect(() => {
    document.title = "앱별 정책과 지원 | kwangbok.me";
  }, []);

  return (
    <SiteLayout crumb="legal">
      <div className="docs">
        <div className="docs-head">
          <h1 className="docs-h1 docs-h1--xl">앱별 정책과 지원</h1>
          <p className="docs-muted">앱마다 개인정보처리방침, 이용약관, 고객지원, 계정 삭제 안내 페이지가 있습니다.</p>
        </div>
        <div className="docs-query docs-mono" aria-hidden="true">
          <span className="docs-kw">SELECT</span> app, privacy, terms, support, delete_account{" "}
          <span className="docs-kw">FROM</span> policy;
        </div>
        <div className="docs-card">
          <table className="docs-table docs-table--stack">
            <thead>
              <tr>
                <th scope="col">app</th>
                {COLS.map((c) => (
                  <th key={c.key} scope="col">
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {APPS.map((app) => (
                <tr key={app.slug} className={app.pinned ? "is-pinned" : undefined}>
                  <th scope="row">
                    <Link to={`/apps/${app.slug}`} className="docs-table-app docs-link">
                      <AppIcon app={app} />
                      {app.name}
                    </Link>
                  </th>
                  {COLS.map((c) => (
                    <td key={c.key} data-label={c.label}>
                      {c.key === "delete-account" && !app.has_account ? (
                        <span className="docs-muted">해당 없음</span>
                      ) : (
                        <Link
                          to={`/apps/${app.slug}/${c.key}`}
                          className="docs-link"
                          aria-label={`${app.name} ${c.name}`}
                        >
                          보기
                        </Link>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <dl className="docs-card docs-info">
          {APPS.map((app) => (
            <div key={app.slug}>
              <dt className="docs-mono docs-muted">{app.slug}</dt>
              <dd>
                {app.operator.name}
                <a href={mailto(undefined, undefined, app.operator.email)} className="docs-link docs-info-sub">
                  {app.operator.email}
                </a>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </SiteLayout>
  );
}
